// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
    background-color: #ffffff;
    position: sticky;
    top: 0;
    padding: 10px 30px;
    display: flex;
    align-items: center;
    box-shadow: 0px 3px 6px #0000001C;
    opacity: 1;
    height: 80px;
    width: 100%;
    z-index: 100;
}

.navbar-items {
    display: flex;
}

.navbar-logo {
    margin-right: 40px;
}

.navbar-heading {
    margin-top: 10px;
}

.navbar-heading h1 {
    font-size: 16px;
    font-weight: 500;
    margin: 0;
    margin-bottom: 5px;
    color: #5A5656;
}

.navbar-heading p{
    margin: 0;
    color: #A0A0A0;
    opacity: 1;
    font-size: 10px;
}

.navbar .user {
    display: flex;
    gap: 15px;
}

.navbar .user-pill {
    display: flex;
    gap: 5px;
    justify-content: center;
    align-items: center;
    background-color: #F4F5F7;
    border-radius: 4px;
    padding-inline: 10px;
}

.user .notification {
    display: flex;
    align-items: center;
}

.initials-avatar {
    height: 30px !important;
    width: 30px !important;
    font-weight: 600 !important;
    background-color: #2300E5 !important;
}

.details h2 {
    font-size: 14px;
    color: #2A2F5C;
    font-weight: 600;
    margin: 0;
    margin-top: 10px;
}

.details p {
    color: #919191;
    margin-bottom: 5px;
    font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/components/navbar/Header.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,MAAM;IACN,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,iCAAiC;IACjC,UAAU;IACV,YAAY;IACZ,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,2BAA2B;IAC3B,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB","sourcesContent":[".navbar {\n    background-color: #ffffff;\n    position: sticky;\n    top: 0;\n    padding: 10px 30px;\n    display: flex;\n    align-items: center;\n    box-shadow: 0px 3px 6px #0000001C;\n    opacity: 1;\n    height: 80px;\n    width: 100%;\n    z-index: 100;\n}\n\n.navbar-items {\n    display: flex;\n}\n\n.navbar-logo {\n    margin-right: 40px;\n}\n\n.navbar-heading {\n    margin-top: 10px;\n}\n\n.navbar-heading h1 {\n    font-size: 16px;\n    font-weight: 500;\n    margin: 0;\n    margin-bottom: 5px;\n    color: #5A5656;\n}\n\n.navbar-heading p{\n    margin: 0;\n    color: #A0A0A0;\n    opacity: 1;\n    font-size: 10px;\n}\n\n.navbar .user {\n    display: flex;\n    gap: 15px;\n}\n\n.navbar .user-pill {\n    display: flex;\n    gap: 5px;\n    justify-content: center;\n    align-items: center;\n    background-color: #F4F5F7;\n    border-radius: 4px;\n    padding-inline: 10px;\n}\n\n.user .notification {\n    display: flex;\n    align-items: center;\n}\n\n.initials-avatar {\n    height: 30px !important;\n    width: 30px !important;\n    font-weight: 600 !important;\n    background-color: #2300E5 !important;\n}\n\n.details h2 {\n    font-size: 14px;\n    color: #2A2F5C;\n    font-weight: 600;\n    margin: 0;\n    margin-top: 10px;\n}\n\n.details p {\n    color: #919191;\n    margin-bottom: 5px;\n    font-size: 12px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
